<!-- eslint-disable @angular-eslint/template/no-call-expression -->
@let eventData = eventData$ | async;
@if (piece) {
  @if (piece.settings?.general?.showEmbedCode && embedFrame) {
    <idt-common-styles-render [styles]="settings?.styles">
      <div
        class="iframe"
        data-e2e="iframe"
        [innerHtml]="embedFrame">
      </div>
    </idt-common-styles-render>
  } @else if (eventData && (array.isArray(eventData) ? eventData.length > 0 : true)) {
  @let event = array.isArray(eventData) ? eventData[0] : eventData;
  <idt-common-styles-render [styles]="settings?.styles">
    <div class="event-section-title">
      {{ piece.settings?.general?.nextEventText! | uppercase }}
    </div>

    <div
      class="event-container"
      [class.event-container--without-media]="!event?.media?.[0]?.url">
      @if (event?.media?.[0]?.url) {
        <div class="event-media-container">
          <img
            class="event-media"
            [src]="event.media[0].url"
            alt="{{ event?.detailedInfo?.provider?.name || 'Event image' }}"
            loading="lazy">
        </div>
      }

      <div class="event-content-container">
        @if (!!userRegistered) {
          @if(userRegistered === 'REGISTERED') {
            <div class="event-info-item event-registered">
              {{ piece.settings?.general?.bookingConfirmedText || 'Reservation confirmed' }}
            </div>
          } @else {
            <div class="event-info-item event-registered">
              {{ piece.settings?.general?.youAreOnWaitlistText || 'You are on the waitlist' }}
            </div>
          }
        } @else {
          @if (piece.settings?.general?.showAvailablePlaces && (event?.detailedInfo?.capacity && event.detailedInfo.capacity! - (event.detailedInfo.occupancy || 0) > 0)) {
            @if(!this.isComingSoon(event)) {
              <div class="event-info-item event-info-capacity event-free">
                {{ replaceCapacityPlaceholder(
                  piece.settings?.general?.nSpotsLeftText!,
                  event.detailedInfo.capacity! - (event.detailedInfo.occupancy || 0)
                ) }}
              </div>
            }
          } @else {
            <div class="event-info-item event-info-capacity event-sold-out">
              {{ piece.settings?.general?.soldOutText! }}
            </div>
          }
        }

        <div class="event-copy-container">
          @if (piece.settings?.general?.showEventText && event?.name) {
            <div
              class="wysiwyg event-title"
              role="heading"
              aria-level="2">
              <render-wysiwyg
                [html]="event.name"
                [country]="country"
                [lang]="lang"
                [piece]="piece">
              </render-wysiwyg>
            </div>
          }
        </div>

        <div class="event-meta-list">
          @if (piece.settings?.general?.showPlace && event?.detailedInfo?.provider?.name) {
            <div class="event-info-item event-info-place">
              <div>
                {{ event?.detailedInfo?.provider?.name }}
              </div>
            </div>
          }

          @if ((piece.settings?.general?.showDate || piece.settings?.general?.showTime) && event?.detailedInfo?.startDateTime) {
            <div class="event-info-item event-info-date-time">
              @if (piece.settings?.general?.showDate) {
                <div>{{ event?.detailedInfo?.startDateTime | safeDate:'EEEE, d MMMM':undefined:languageTag | titlecase }}</div>
              }
              @if (piece.settings?.general?.showTime) {
                <div>{{ event?.detailedInfo?.startDateTime | safeDate:'HH:mm':undefined:languageTag }}</div>
              }
            </div>
          }
        </div>
        @if (piece.settings?.general?.showEventText && event?.description) {
          <div
            class="wysiwyg event-description"
            role="region"
            aria-label="Event Description">
            <render-wysiwyg
              [html]="event.description"
              [country]="country"
              [lang]="lang"
              [piece]="piece">
            </render-wysiwyg>
          </div>
        }

        <div class="event-actions-container">
          @if(!!userRegistered) {
            <span class="event-booking-confirmation-text">
              {{ piece.settings?.general?.bookingConfirmationText }}
            </span>
            <div class="event-cancel-footer">
              <span>{{ piece.settings?.general?.cantAttendText }}</span>
              <button
                class="event-cancel-btn"
                (click)="onCancelReservation(event.id)"
                type="button">{{ piece.settings?.general?.cancelYourBookingText }}</button>
            </div>
          } @else {
            <button
              class="event-reserve-btn"
              (click)="onReserveClick(event)"
              [disabled]="isRegistrationClosed(event)"
              type="button">
              @if(this.isComingSoon(event)) {
                {{ (piece.settings?.general?.comingSoonText! || 'Coming Soon') | uppercase }}
              } @else {
                @if (event?.detailedInfo?.capacity && event.detailedInfo.capacity! - (event.detailedInfo.occupancy || 0) > 0) {
                  @if (isLoggedIn) {
                    {{ piece.settings?.general?.bookYourSpotText! | uppercase}}
                  } @else {
                    {{ piece.settings?.general?.signInToBookYourSpotText! | uppercase}}
                  }
                }
                @else {
                  @if (isLoggedIn) {
                    {{ piece.settings?.general?.joinWaitlistText! | uppercase}}
                  } @else {
                    {{ piece.settings?.general?.signInToJoinWaitlistText! | uppercase}}
                  }
                }
              }
            </button>
          }
        </div>
      </div>
    </div>

    <render-modal-panel
      aria-label="Reservation"
      #eventReservationModal="render-modal-panel"
      [modalName]="reservationModalName"
      [scrollableOnSmallViewport]="true"
      [modalType]="isMobile ? 'full' : 'large'">
      @if (eventReservationModal.open) {
        <piece-events-reservation-modal
          [event]="selectedEvent"
          [piece]="piece"
          [country]="country"
          [lang]="lang"
          [languageTag]="languageTag"
          [storeId]="storeId"
          (reservationRegistered)="onReservationRegistered($event)"
          [accessToken]="accessToken">
        </piece-events-reservation-modal>
      }
    </render-modal-panel>

    <render-modal-panel
      [modalName]="reservationConfirmationToastName"
      modalType="toast"
      [addToBody]="true"
      [closeOnOutsideClick]="false"
      [hasToShowCloseButton]="false">
      <div
        class="event-reservation-confirmation-toast"
        role="status"
        aria-live="polite">
        {{ piece.settings?.general?.bookingConfirmationText }}
      </div>
    </render-modal-panel>
  </idt-common-styles-render>
  } @else if (embedFrame) {
    <idt-common-styles-render [styles]="settings?.styles">
      <div
        class="iframe"
        data-e2e="iframe"
        [innerHtml]="embedFrame">
      </div>
    </idt-common-styles-render>
  }
}
